const bodyScrollLock = require('body-scroll-lock');
const disableBodyScroll = bodyScrollLock.disableBodyScroll;
const enableBodyScroll = bodyScrollLock.enableBodyScroll;
const { createFocusTrap } = require('focus-trap');

export function mobileBreakpoint() {
    return 768;
}

export function headerBreakpoint() {
    return 980;
}

export const mobileHandler = {
    init: () => {

        mobileHandler.isMobile();
        mobileHandler.setRealVH();
        mobileHandler.mobileNav();
        mobileHandler.mobileFilters();
        mobileHandler.ux();

        // let mobileNav;

        window.addEventListener('resize', () => {
            // console.log("resize");
            mobileHandler.isMobile();
            mobileHandler.setRealVH();
            // clearTimeout(mobileNav);
            // mobileNav = setTimeout(mobileHandler.mobileNav(), 500);
            mobileHandler.ux();
        });

    },

    isMobile: () => {
        let isMobile = getViewportWidth() < mobileBreakpoint();
        if (isMobile) {
            document.body.classList.add('mobile');
        } else {
            document.body.classList.remove('mobile');
        }
    },

    setRealVH: () => {
        // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
        let vh = window.innerHeight * 0.01;
        // Then we set the value in the --vh custom property to the root of the document
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    mobileNav: () => {
        let isMobile = getViewportWidth() < headerBreakpoint();
        let $burger = document.querySelector('.btn--toggle-menu');

        if ($burger) {
            let $header = document.querySelector('.header--main');
            let $menuParentWrap = $header.querySelector('.header--main-wrap');
            let $navMain = $menuParentWrap.querySelector('.nav--main .menu-wrap > ul');
            let $filtersWrap = document.querySelector('.posts--filters');
            let $menuFocusTrap = createFocusTrap($menuParentWrap);

            document.addEventListener('click', (e) => {
                // Hack sticky Header
                if (window.scrollY === 0) {
                    window.scrollTo({
                        'top': 1,
                        'behavior': 'auto'
                    });
                }

                // console.log('document: '+e.target);
                if (e.target === $burger) {
                    $burger.classList.toggle('opened');
                    $header.classList.toggle('opened');
                    $menuParentWrap.classList.toggle('opened');
                    mobileHandler.closeAllSubmenus();

                    if ($menuParentWrap.classList.contains('opened')) {
                        $menuParentWrap.setAttribute('role', 'dialog');
                        $menuParentWrap.setAttribute('aria-modal', 'true');
                        $menuParentWrap.setAttribute('aria-label', 'menu');
                        $burger.classList.remove('closed');
                        disableBodyScroll($navMain);
                        $menuFocusTrap.activate();
                    } else {
                        $burger.classList.add('closed');
                        enableBodyScroll($navMain);
                        $menuParentWrap.removeAttribute('role');
                        $menuParentWrap.removeAttribute('aria-modal');
                        $menuParentWrap.removeAttribute('aria-label');
                        $menuFocusTrap.deactivate();
                    }
                    // Close Publications filters if opened
                    if ($filtersWrap) {
                        $filtersWrap.classList.remove('expanded');
                        enableBodyScroll($filtersWrap);
                    }
                }

            })
            // }

            /** Close mobile menu on ESC */
            document.addEventListener("keydown", ({ key }) => {
                if (key === "Escape") {
                    $burger.classList.remove('opened');
                    $header.classList.remove('opened');
                    $menuParentWrap.classList.remove('opened');
                    mobileHandler.closeAllSubmenus();
                    $burger.classList.add('closed');
                    enableBodyScroll($navMain);
                    $menuParentWrap.removeAttribute('role');
                    $menuParentWrap.removeAttribute('aria-modal');
                    $menuParentWrap.removeAttribute('aria-label');
                    $menuFocusTrap.deactivate();
                }
            });

            /** MANAGE SUBMENU **/
            let $anchorSubmenus = document.querySelectorAll('.has-submenu > a, .has-megamenu > a');
            if ($anchorSubmenus) {

                Array.prototype.forEach.call($anchorSubmenus, ($anchorSubmenu) => {
                    if (isMobile) {
                        $anchorSubmenu.addEventListener('click', mobileHandler.toggleSubmenu);
                    } else {
                        $anchorSubmenu.removeEventListener('click', mobileHandler.toggleSubmenu);
                    }
                });

                // Auto close submenus when clicking outside
                let $navContent = document.querySelector('.menu-wrap ul');
                document.addEventListener('click', (e) => {
                    if (e.target !== $navContent && !$navContent.contains(e.target)) {
                        mobileHandler.closeAllSubmenus();
                    }
                });

            }
        }

    },

    mobileFilters: () => {
        let isMobile = getViewportWidth() < headerBreakpoint();
        let $filtersWrap = document.querySelector('.layout-list__filters');

        if ($filtersWrap) {
            let $btnExpand = document.querySelectorAll('.btn--filters-mobile');
            let $btnClose = $filtersWrap.querySelectorAll('.btn--filters-close');

            Array.prototype.forEach.call($btnExpand, ($btn) => {
                $btn.classList.remove('hidden')
                $btn.addEventListener('click', () => {
                    $filtersWrap.classList.toggle('expanded')
                    if ($filtersWrap.classList.contains('expanded')) {
                        disableBodyScroll($filtersWrap)
                    } else {
                        enableBodyScroll($filtersWrap);
                    }
                })

                let observer = new IntersectionObserver(
                    ([e]) => e.target.classList.toggle('isSticky', e.intersectionRatio < 1),
                    { threshold: [1] }
                );

                observer.observe($btn)
            })

            Array.prototype.forEach.call($btnClose, ($btn) => {
                $btn.addEventListener('click', () => {
                    $filtersWrap.classList.remove('expanded')
                    enableBodyScroll($filtersWrap);
                })
            })


        }
    },

    toggleSubmenu: (el) => {
        el.preventDefault();
        let target = el.target.closest('a');

        if (target.classList.contains('submenu-parent') && getViewportWidth() < headerBreakpoint()) {

            let $parentToToggle = target.closest('li.has-submenu, li.has-megamenu');
            let $parentIsOpened = $parentToToggle.classList.contains('expanded') ? true : false;

            mobileHandler.closeAllSubmenus();

            if (!$parentIsOpened) {
                $parentToToggle.classList.toggle('expanded');
            } else {
                window.location = target.href;
            }

        }
    },

    closeAllSubmenus: () => {
        let $submenus = document.querySelectorAll('li.has-submenu, li.has-megamenu');
        if ($submenus) {
            Array.prototype.forEach.call($submenus, ($submenu) => {
                $submenu.classList.remove('expanded');
            });
        }
    },

    ux: () => {
        let $header = document.querySelector('.header--main');
        let isMobile = getViewportWidth() < mobileBreakpoint();

        if (!$header) return;

        let $mobileParent = $header.querySelector('.menu-wrap');

        // Move Header Pre for Mobile
        let $headerPre = $header.querySelector('.header--pre');

        if ($headerPre && !$mobileParent.querySelector('.header--pre') && getViewportWidth() < headerBreakpoint()) {
            $mobileParent.appendChild($headerPre);
        } else if (!isMobile && $mobileParent.querySelector('.header--pre')) {
            $header.insertBefore($headerPre, $header.firstChild);
        }

        // Move Search form
        // let $searchform = $header.querySelector('.header--main-search');

        // if ($searchform && !$mobileParent.querySelector('.header--main-search') && getViewportWidth() < headerBreakpoint()) {
        //     $mobileParent.insertBefore($searchform, $mobileParent.firstChild);
        // } else if (!isMobile && $mobileParent.querySelector('.header--main-search')) {
        //     // $header.insertBefore($headerPre, $header.firstChild);
        //     let $desktopParent = $header.querySelector('.header--main-wrap');
        //     $desktopParent.appendChild($searchform);
        // }

        // Hover effect
        let $parentNavItems = document.querySelectorAll('.menu-wrap>ul>li');
        if ($parentNavItems) {

            Array.prototype.forEach.call($parentNavItems, ($parentNavItem) => {
                $parentNavItem.addEventListener('mouseover', () => {
                    let $excludes = Array.from($parentNavItems).filter(node => node !== $parentNavItem);
                    Array.prototype.forEach.call($excludes, ($exclude) => {
                        $exclude.classList.add('reduce')
                    });
                });
                $parentNavItem.addEventListener('mouseout', () => {
                    Array.prototype.forEach.call($parentNavItems, ($parentNavItem) => {
                        $parentNavItem.classList.remove('reduce')
                    });
                });
            });


            $mobileParent.addEventListener('mouseout', () => {
                Array.prototype.forEach.call($parentNavItems, ($parentNavItem) => {
                    $parentNavItem.classList.remove('reduce')
                });
            });

        }

    },

    returnNav: () => {
        // let $menuReturn = document.createElement('li');
        // $menuReturn.classList.add('submenu-return');
        // $menuReturn.innerHTML = '&lt; Retour';
    }
}

export function getViewportWidth() {
    let viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    return viewportWidth;
}